var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("validation-observer", {
    ref: "EditDesignationForm",
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function (ref) {
          var invalid = ref.invalid
          var errors = ref.errors
          return [
            _c(
              "b-form",
              {
                on: {
                  submit: function ($event) {
                    $event.preventDefault()
                    return _vm.formSubmitted($event)
                  },
                },
              },
              [
                _c(
                  "b-row",
                  [
                    _c(
                      "b-col",
                      { attrs: { sm: "12" } },
                      [
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              label: "Department",
                              "label-for": "department",
                              invalid: errors.departmentId,
                            },
                          },
                          [
                            _c("b-form-select", {
                              attrs: { options: _vm.departmentOptions },
                              model: {
                                value: _vm.designation.departmentId,
                                callback: function ($$v) {
                                  _vm.$set(_vm.designation, "departmentId", $$v)
                                },
                                expression: "designation.departmentId",
                              },
                            }),
                            _c("small", { staticClass: "text-danger" }, [
                              _vm._v(_vm._s(errors.departmentId)),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { md: "12" } },
                      [
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              label: "Working Hours",
                              "label-for": "workingHours",
                              invalid: errors.workingHours,
                            },
                          },
                          [
                            _c("validation-provider", {
                              attrs: {
                                name: "Working Hours",
                                rules: "required|max_working_hours",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (ref) {
                                      var errors = ref.errors
                                      return [
                                        _c("b-form-input", {
                                          attrs: {
                                            name: "workingHours",
                                            placeholder: "Working Hours",
                                          },
                                          model: {
                                            value: _vm.designation.workingHours,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.designation,
                                                "workingHours",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "designation.workingHours",
                                          },
                                        }),
                                        _c(
                                          "small",
                                          { staticClass: "text-danger" },
                                          [_vm._v(_vm._s(errors[0]))]
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { md: "12" } },
                      [
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              label: "Designation Name",
                              "label-for": "designationName",
                              invalid: errors.designationName,
                            },
                          },
                          [
                            _c("validation-provider", {
                              attrs: {
                                name: "Designation Name",
                                rules: "required",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (ref) {
                                      var errors = ref.errors
                                      return [
                                        _c("b-form-input", {
                                          attrs: {
                                            name: "designationName",
                                            placeholder: "Designation Name",
                                          },
                                          model: {
                                            value:
                                              _vm.designation.designationName,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.designation,
                                                "designationName",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "designation.designationName",
                                          },
                                        }),
                                        _c(
                                          "small",
                                          { staticClass: "text-danger" },
                                          [_vm._v(_vm._s(errors[0]))]
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { md: "12" } },
                      [
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              label: "Minimum Salary",
                              "label-for": "minimumSalary",
                            },
                          },
                          [
                            _c("validation-provider", {
                              attrs: {
                                name: "minimumSalary",
                                rules: [
                                  {
                                    required: true,
                                    message: "Minimum Salary is required",
                                  },
                                  {
                                    numeric_decimal: true,
                                    message: "Please enter a valid number",
                                  },
                                  {
                                    validate: function (value) {
                                      return (
                                        value >= 0 ||
                                        "Salary cannot be negative"
                                      )
                                    },
                                    message: "Salary cannot be negative",
                                  },
                                ],
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (ref) {
                                      var errors = ref.errors
                                      return [
                                        _c("b-form-input", {
                                          attrs: {
                                            type: "number",
                                            name: "minimumSalary",
                                            placeholder: "Minimum Salary",
                                          },
                                          on: {
                                            input: _vm.checkNegative,
                                            blur: _vm.validate,
                                          },
                                          model: {
                                            value:
                                              _vm.designation.minimumSalary,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.designation,
                                                "minimumSalary",
                                                _vm._n($$v)
                                              )
                                            },
                                            expression:
                                              "designation.minimumSalary",
                                          },
                                        }),
                                        _c(
                                          "small",
                                          { staticClass: "text-danger" },
                                          [_vm._v(_vm._s(errors[0]))]
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { md: "12" } },
                      [
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              label: "Maximum Salary",
                              "label-for": "maximumSalary",
                            },
                          },
                          [
                            _c("validation-provider", {
                              attrs: {
                                name: "maximumSalary",
                                rules: [
                                  {
                                    required: true,
                                    message: "Minimum Salary is required",
                                  },
                                  {
                                    numeric_decimal: true,
                                    message: "Please enter a valid number",
                                  },
                                  {
                                    validate: function (value) {
                                      return (
                                        value >= 0 ||
                                        "Salary cannot be negative"
                                      )
                                    },
                                    message: "Salary cannot be negative",
                                  },
                                ],
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (ref) {
                                      var errors = ref.errors
                                      return [
                                        _c("b-form-input", {
                                          attrs: {
                                            type: "number",
                                            name: "maximumSalary",
                                            placeholder: "Maximum Salary",
                                          },
                                          on: {
                                            input: _vm.checkNegative,
                                            blur: _vm.validate,
                                          },
                                          model: {
                                            value:
                                              _vm.designation.maximumSalary,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.designation,
                                                "maximumSalary",
                                                _vm._n($$v)
                                              )
                                            },
                                            expression:
                                              "designation.maximumSalary",
                                          },
                                        }),
                                        _c(
                                          "small",
                                          { staticClass: "text-danger" },
                                          [_vm._v(_vm._s(errors[0]))]
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      {
                        staticClass: "d-flex justify-content-between",
                        attrs: { md: "12" },
                      },
                      [
                        _c(
                          "b-button",
                          {
                            attrs: {
                              type: "submit",
                              variant: "primary",
                              disabled: invalid,
                            },
                          },
                          [_vm._v(" Save ")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }